import { render, staticRenderFns } from "./SendEmailFormComponent.vue?vue&type=template&id=0aab7ba0&scoped=true"
import script from "./SendEmailFormComponent.vue?vue&type=script&lang=js"
export * from "./SendEmailFormComponent.vue?vue&type=script&lang=js"
import style0 from "./SendEmailFormComponent.vue?vue&type=style&index=0&id=0aab7ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab7ba0",
  null
  
)

export default component.exports